import React from "react"

export default function Home() {
  return (
    <symbol id="svg-home" viewBox="0 0 35 37">
      <path
        fill="currentColor"
        d="M33.4 12.2L18.4.5c-.7-.5-1.5-.5-2 0l-15 11.7c-.5.3-.7.8-.7 1.3v18.3c0 2.8 2.2 5 5 5H29c2.8 0 5-2.2 5-5V13.5c0-.5-.1-1-.6-1.3zM20.7 33.5H14V20.2h6.7v13.3zm10-1.7c0 1-.7 1.7-1.7 1.7h-5v-15c0-1-.7-1.7-1.7-1.7h-10c-1 0-1.7.7-1.7 1.7v15h-5c-1 0-1.7-.7-1.7-1.7V14.4L17.4 4l13.3 10.3v17.5z"
      />
    </symbol>
  )
}
